import {Record, Map} from 'immutable';
import type {RecordOf} from 'immutable';
import {isNil} from '@packages/utilities/fp/utils';
import {weakMemo} from '@packages/utilities/memo';

type VideoRecordProps = {
  url: string | null | undefined;
  html: string | null | undefined;
  title: string | null | undefined;
  description: string | null | undefined;
  width: number;
  height: number;
  aspectRatio: number;
  provider_name: string | null | undefined;
  author_name: string | null | undefined;
  thumbnail_url: string | null | undefined;
  type: string | null | undefined;
};

export type VideoRecordType = RecordOf<VideoRecordProps>;

const VideoRecord = Record<VideoRecordProps>(
  {
    url: null,
    html: null,
    title: null,
    description: null,
    width: 0,
    height: 0,
    aspectRatio: 0,
    provider_name: null,
    author_name: null,
    thumbnail_url: null,
    type: null,
  },
  'VideoRecord'
);

// @ts-expect-error - TS7031 - Binding element 'meta' implicitly has an 'any' type. | TS7031 - Binding element 'response' implicitly has an 'any' type.
export const getVideoFetchResponse = weakMemo(({meta, response}) =>
  reify(response.set('url', meta.get('url')))
);

// @ts-expect-error - TS7006 - Parameter 'value' implicitly has an 'any' type.
export const videoRecordToMap = weakMemo((value) => Map(value));

// @ts-expect-error - TS7006 - Parameter 'raw' implicitly has an 'any' type.
export const reify = weakMemo((raw) => {
  if (isVideo(raw)) {
    return raw;
  }

  const {url, metadata = {}, ...rest} = raw.toJS();

  return new Video({
    aspectRatio: aspectRatio(metadata.width, metadata.height),
    ...metadata,
    ...rest,
    url,
  });
});

export default class Video extends VideoRecord {
  // @ts-expect-error - toJSON cannot return null
  toJSON() {
    return this.url ? {url: this.url, metadata: jsonify(this)} : null;
  }
}

const isVideo = (x: any) => x instanceof Video;
const isNumber = (x: any) => typeof x === 'number';

function aspectRatio(w: any, h: any) {
  return isNumber(w) && isNumber(h) ? w / h : 0;
}

function jsonify(metadata: Video) {
  return (
    metadata
      // TODO: Add toMap type to Record type in flow-typed/immutable
      // @ts-expect-error - TS2339 - Property 'toMap' does not exist on type 'Video'.
      .toMap()
      .delete('url')
      .filterNot(isNil)
      .toJSON()
  );
}
